export class DemandeModif {
    constructor(
        public id?: number,
        public entityId?: number,
        public entityType?: string,
        public titre?: string,
        public description?: string,
        public createdBy?: string,
        public createdDate?: Date,
        public lastModifiedBy?: string,
        public lastModifiedDate?: Date
    ) {
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/blocks/demande-modif/demande-modif.model.ts